module.exports = __webpack_public_path__ + "static/media/blog-41-1.9b205318.webp";